<script>
import {defineComponent} from 'vue'

import Vue3autocounter from 'vue3-autocounter';

export default defineComponent({
    name: "IdleMiner",
    components: {
        'vue3-autocounter': Vue3autocounter
    },
    props: {
        startDate: {
            type: Date,
            default: () => new Date(new Date().setHours(0, 0, 0, 0)), // 00:00 this morning
        },
        endDate: {
            type: Date,
            default: function () {
                let start = new Date(new Date().setHours(0, 0, 0, 0));
                return new Date(start.setDate(start.getDate() + 7)); // 7 days from startDate
            },
        },
        interestRate: {
            type: Number,
            default: 7.5, // 7.5% APY
        },
    },
    data() {
        return {
            userStake: 2.5*1e9, // Example starting value
            progressValues: {
                '10000s': 0,
                '1000s': 0,
                '100s': 0,
                '10s': 0,
                '1s': 0,
                '0.1s': 0,
                // '0.01s': 0,
            },
            stepValues: {
                '10000s': 0,
                '1000s': 0,
                '100s': 0,
                '10s': 0,
                '1s': 0,
                '0.1s': 0,
                // '0.01s': 0,
            },
            maxValues: {
                '10000s': 10000,
                '1000s': 1000,
                '100s': 100,
                '10s': 10,
                '1s': 1,
                '0.1s': 0.1,
                // '0.01s': 0.01,
            },

            counterStartedAt: new Date(),
            countedStake: 0.0001
        };
    },
    created() {
        this.calculateProgress();
        this.counterStartedAt = new Date();

    },
    mounted() {
        this.$refs.counter.start();
        this.$watch(
            '$refs.counter.currentAmount',
            (newAmount) => {
                this.countedStake = newAmount;
                this.animateProgressBars(newAmount);
            }
        )
        this.$refs.counterUSD.start();
    },
    watch: {
        userStake() {
            this.calculateProgress();
            this.counterStartedAt = new Date();
            setTimeout(() => {
                this.$refs.counter.start();
                this.$refs.counterUSD.start();
            }, 50);
            // this.$refs.counter.start();
        },

    },
    methods: {
        calculateProgress() {
            let remainingStake = this.userStake;

            // Calculate each progress bar value
            Object.keys(this.maxValues).forEach((key) => {
                const unitValue = this.maxValues[key] * 1e9;
                this.stepValues[key] = Math.floor(remainingStake / unitValue);
                remainingStake %= unitValue;
            });
        },
        increment(level) {
            const incrementAmount = this.maxValues[level] * 1e9;
            this.userStake += incrementAmount;
            console.log(this.$refs.counter)

        },
        calculateAmount(date) {
            const elapsedSeconds = (date - this.startDate) / 1000;
            const annualInterest = this.userStake * (this.interestRate / 100);
            const earnedInterest = (annualInterest / 31536000) * elapsedSeconds; // seconds in a year
            return (this.userStake + earnedInterest) / 1e9;
        },
        animateProgressBars(currentAmount) {
            const scaledAmount = currentAmount  ; // Scale up the amount
            const decimalPart = scaledAmount //- Math.floor(scaledAmount);

            // Calculate percentage for each progress bar
            Object.keys(this.maxValues).forEach((key, index) => {
                if (scaledAmount > 1300 * this.maxValues[key]) {
                    this.progressValues[key] = 100; // Set to 100% if condition is met
                } else if (scaledAmount > this.maxValues[key]) {
                    this.progressValues[key] = this.calculatePercentage(decimalPart, index + 1);
                } else {
                    this.progressValues[key] = 0;
                }
            });
            // console.log({currentAmount, scaledAmount, decimalPart, progressValues: this.progressValues['0.1s']})
        },
        calculatePercentage(number, place) {
            // take place digits from the right of the number
            let uprated = number * Math.pow(10, place + 1);
            let decimal = uprated - Math.floor(uprated)
            return decimal *100;

        },

    },
    computed: {
        startAmount() {
            return this.calculateAmount(this.counterStartedAt);
        },
        endAmount() {
            return this.calculateAmount(this.endDate);
        },
        duration() {
            const now = this.counterStartedAt;
            return (this.endDate - now) / 1000; // duration in seconds
        },
        uiDecimals() {
            // as this.countedStake gets 10x larger, the decimals get smaller by 1
            return Math.max(0, 11 - Math.floor(Math.log10(this.countedStake)));
        },
    },
})
</script>

<template>
    <div class="w-50 mx-auto mt-5 mb-5 text-center">
        <h1>⛏️ SOLMiner</h1>
        <h3>Idle Mining Stake Pool</h3>
        <h5>Your Stake:</h5>
        <div class="display-3 mt-5">
            <vue3-autocounter
                ref="counter"
                :startAmount="startAmount"
                :endAmount="endAmount"
                :duration="duration"
                prefix=""
                suffix=" SOL"
                separator=","
                decimalSeparator="."
                :decimals="uiDecimals"
                :autoinit="false"
            />
        </div>
        <div class="text-muted display-5">
            <vue3-autocounter
                ref="counterUSD"
                :startAmount="startAmount * 59.75"
                :endAmount="endAmount * 59.75"
                :duration="duration"
                prefix="~$"
                suffix=" USD"
                separator=","
                decimalSeparator="."
                :decimals="uiDecimals+2"
                :autoinit="false"
            />
        </div>

        <!-- Loop through each progress bar -->

        <div v-for="(value, key) in progressValues" :key="key" class="row my-1 ">
            <!--            <div class="small col-1">
                            {{ maxValues[key].toLocaleString() }} SOL
                        </div>-->
            <!-- Progress Bar -->
            <div class="col col-9">

                <b-progress :max="100"  :animated="value === 100" variant="warning" :value="value" class="h-50"/>
            </div>
            <div class="col-3">

                <b-button @click="increment(key)" variant="success"  class="button-game button-important w-100">
                    +{{ maxValues[key].toLocaleString() }} SOL<br>
                    <b-progress :max="10" class="w-100" style="height:4px"  :value="stepValues[key]" >
                        <b-progress-bar :max="10" :value="stepValues[key]"  style="height:4px; background: #fff" />
                    </b-progress>
                </b-button>

            </div>
            <!-- Increment Button -->
        </div>
        <small class="text-muted">Click [+] to add the desired amount of stake and watch your rewards increase in real
            time!</small>
        <div class="my-5"></div>
    </div>
</template>

<style >
.button-game {
    /* background-color: #5def62; !* Green background *!
    */
    border: none;
    color: white;
    /*padding: 10px 20px;*/
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 14px;
    font-weight: 800;
    /*  margin: 4px 2px;
      cursor: pointer;
      border-radius: 12px;
      box-shadow: 0 4px #186901;*/
}

.button-game:hover {
    background-color: #45a049;
}

.button-game:active {
    /*  background-color: #3e8e41;
      box-shadow: 0 2px #666;*/
    transform: translateY(2px);
}

@keyframes pulse {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.05);
    }
    100% {
        transform: scale(1);
    }
}

.button-important {
    animation: pulse 1s infinite;
}

/* Make .display-2 and .display-5 mono spaced fonts */
.display-3, .display-5 {
    font-family: monospace;
}
body .progress-bar {
    transition: none;
}
body .progress-bar-animated {
    animation: progress-bar-stripes .2s linear infinite;
}
</style>
